export const AllowedCardElements = ['div', 'article', 'details', 'main', 'section', 'aside'];
//# sourceMappingURL=types.js.map